import { render, staticRenderFns } from "./reporte-historial-jugador.vue?vue&type=template&id=5cbd4fdf&scoped=true"
import script from "./reporte-historial-jugador.vue?vue&type=script&lang=js"
export * from "./reporte-historial-jugador.vue?vue&type=script&lang=js"
import style0 from "./reporte-historial-jugador.vue?vue&type=style&index=0&id=5cbd4fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd4fdf",
  null
  
)

export default component.exports